"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryList = queryList;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryList(data) {
  return (0, _request.default)({
    url: '/portal/system/operation/record/list',
    method: 'post',
    data: data
  });
}